export const isHicampus = process.env.NEXT_PUBLIC_APP_NAME === 'hicampus'
export const isSoluny = process.env.NEXT_PUBLIC_APP_NAME === 'soluny'
export const isBridge = process.env.NEXT_PUBLIC_APP_NAME === 'bridge'
